<template>
  <div class="menu-drawer__linklist">
    <ul class="menu-drawer__linklist-wrapper">
      <li class="menu-drawer__linklist-item">
        <p
          class="text-body-xs-bold"
          v-text="linklist.title"
        />
      </li>

      <li
        v-for="(link, index) in linklist.links"
        :key="index"
        class="menu-drawer__linklist-item"
      >
        <a
          class="text-body-xs menu-drawer__linklist-link"
          :href="link.localisedUrl"
          v-text="link.title"
        />
      </li>
    </ul>
  </div>
</template>

<script>

/**
 * Vue: Menu drawer linklist
 * -----------------------------------------------------------------------------
 * Abstracts away rendering of repeated linklists into a separate component
 * @param {Object} linklist - A single linklist object.
 *
 */

export default {
  name: 'MenuDrawerLinkList',

  props: {
    linklist: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
